export const CLIENT_PROFILE = {
  companyName: 'Abu Dhabi National Oil Company',
  shortCode: 'ADNOC',
  accountId: 'CLI-ADNOC-8842',
  portalTier: 'Enterprise',
};

export const ACTIVE_CONSIGNMENTS = [
  {
    id: 'CON-2401',
    product: 'Jet Fuel (Aviation)',
    volume: '55,000 L',
    origin: 'Ruwais Refinery',
    destination: 'Dubai International Airport (DXB)',
    eta: '12 Jun 2026 · 4:30 PM',
    status: 'in_transit',
    vehicleNumber: 'DXB-T-4021',
    documents: { pod: false, coa: true, msds: true },
  },
  {
    id: 'CON-2402',
    product: 'LPG (Bulk Liquid)',
    volume: '28,500 L',
    origin: 'Jebel Ali Terminal',
    destination: 'Sharjah Industrial City',
    eta: '12 Jun 2026 · 7:15 PM',
    status: 'loading',
    vehicleNumber: 'AUH-L-1155',
    documents: { pod: false, coa: true, msds: true },
  },
  {
    id: 'CON-2403',
    product: 'Gas Oil / Diesel',
    volume: '42,000 L',
    origin: 'Habshan',
    destination: 'Jebel Ali Power Station',
    eta: 'Delivered · 11 Jun 2026',
    status: 'delivered',
    vehicleNumber: 'RUW-G-7721',
    documents: { pod: true, coa: true, msds: true },
  },
  {
    id: 'CON-2404',
    product: 'Bitumen (Bulk)',
    volume: '32 MT',
    origin: 'ADNOC Refinery',
    destination: 'Dubai South Infrastructure',
    eta: '13 Jun 2026 · 9:00 AM',
    status: 'pending_approval',
    vehicleNumber: 'AUH-B-3340',
    documents: { pod: false, coa: false, msds: true },
  },
];

export const CONSIGNMENT_STATUS = {
  in_transit: { label: 'In Transit', className: 'bg-blue-100 text-black' },
  loading: { label: 'Loading', className: 'bg-amber-100 text-black' },
  delivered: { label: 'Delivered', className: 'bg-emerald-100 text-black' },
  pending_approval: { label: 'Pending Approval', className: 'bg-violet-100 text-black' },
};

export const BILLING_LEDGER = [
  {
    id: 'INV-2026-0842',
    type: 'invoice',
    description: 'May 2026 — Dedicated Fleet (5 Tankers)',
    amountAed: 45000,
    status: 'outstanding',
    dueDate: '2026-06-20',
  },
  {
    id: 'INV-2026-0791',
    type: 'invoice',
    description: 'April 2026 — Per-KL Fuel Transport',
    amountAed: 28400,
    status: 'paid',
    dueDate: '2026-05-15',
  },
  {
    id: 'STM-2026-Q2',
    type: 'statement',
    description: 'Q2 2026 Outstanding Statement',
    amountAed: 73400,
    status: 'outstanding',
    dueDate: '2026-07-01',
  },
  {
    id: 'CRD-2026-012',
    type: 'credit',
    description: 'Fuel Saving Rebate — April Performance',
    amountAed: 3200,
    status: 'credit',
    dueDate: 'Applied',
  },
  {
    id: 'INV-2026-0710',
    type: 'invoice',
    description: 'March 2026 — LPG Bulk Deliveries',
    amountAed: 19200,
    status: 'paid',
    dueDate: '2026-04-10',
  },
];

export const BILLING_STATUS = {
  outstanding: { label: 'Outstanding', className: 'bg-red-100 text-black' },
  paid: { label: 'Paid', className: 'bg-emerald-100 text-black' },
  credit: { label: 'Credit Applied', className: 'bg-blue-100 text-black' },
};
